import DOMPurify from 'dompurify';

export abstract class HtmlPurifier {
	static purify(dirtyHtml: string): string {
		const sanitized = DOMPurify.sanitize(dirtyHtml).toString();
		return sanitized;
	}
}
